import { gql } from "@apollo/client";


export const GET_TIMEZONE = gql`
query GetTimeZones {
  getTimeZones {
    timeZone
    timeZoneName
    timeZoneNumber
  }
}
`
